import { Link } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';
import { NavLink } from 'react-router-dom';

import { handleLogout } from '../../slice/appSlice';
import FooterSocialMedia from './FooterSocialMedia';

import './Footer.css';

function Footer({ isLoggedIn }) {
  return (
    <footer className="footer-wrapper">
      <div className="footer-container">
        {/* Social Media / Brand */}
        <div className="footer-section">
          <FooterSocialMedia />
        </div>

        <div className="footer-section">
          <h3 className="footer-section-header">Home</h3>
          <Link className="footer-link" as={NavLink} to="/verify">
            View Certificates
          </Link>
          <div className="footer-link">Our Clients</div>
        </div>

        <div className="footer-section">
          <h3 className="footer-section-header">Company</h3>
          <Link className="footer-link" as={NavLink} to="/about">
            About Us
          </Link>
          <div className="footer-link">Careers</div>
          <Link className="footer-link" as={NavLink} to="/contact">
            Contact
          </Link>
        </div>

        <div className="footer-section">
          <h3 className="footer-section-header">Account</h3>
          {!isLoggedIn && (
            <>
              <Link className="footer-link" as={NavLink} to="/signup">
                Sign Up
              </Link>
              <Link className="footer-link" as={NavLink} to="/login">
                Sign In
              </Link>
              <Link className="footer-link" as={NavLink} to="/reset-password">
                Forgot Password
              </Link>
            </>
          )}
          {isLoggedIn && (
            <>
              <Link
                className="footer-link"
                onClick={handleLogout}
                as={NavLink}
                to="/"
              >
                Log Out
              </Link>
              <Link
                className="footer-link"
                as={NavLink}
                to="/change-password"
              >
                Change Password
              </Link>
            </>
          )}
        </div>

        <div className="footer-section">
          <h3 className="footer-section-header">Get Help</h3>
          <Link className="footer-link" as={NavLink} to="/navigate">
            Navigate the Portal
          </Link>
          <Link className="footer-link" href="mailto:contact@safecert.cloud">
            Contact Sales
          </Link>
          <Link className="footer-link" href="mailto:contact@safecert.cloud">
            Issues with Services
          </Link>
        </div>
      </div>

      <div className="footer-bottom">
        © {new Date().getFullYear()} Safecert. All Rights Reserved.
      </div>
    </footer>
  );
}

Footer.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
};

export default Footer;
